module.exports = __webpack_public_path__ + "img/gjaq1.40040b95.png";